import React, { useMemo } from "react";
import Markdown, { MarkdownProps } from "react-native-markdown-display";

export type MarkdownDisplayProps = {
  markdown: string;
  rules?: MarkdownProps["rules"];
  style?: MarkdownProps["style"];
};

export const MarkdownDisplay = ({
  markdown,
  rules,
  style,
}: MarkdownDisplayProps) => {
  const mergedStyle = useMemo(() => ({ ...markdownStyles, ...style }), [style]);
  return (
    <Markdown rules={rules} style={mergedStyle}>
      {markdown}
    </Markdown>
  );
};

const markdownStyles = {
  body: {
    fontSize: 14,
    lineHeight: 18,
    FontFace: "Inter",
    fontWeight: "500" as "500",
    color: "#001A19",
  },
  view: { color: "#001A19" },
  heading1: {
    fontSize: 28,
    lineHeight: 32,
    marginVertical: 4,
    fontWeight: "500" as "500",
    FontFace: "Inter",
    color: "#001A19",
  },
  heading2: {
    fontSize: 18,
    lineHeight: 24,
    marginVertical: 4,
    fontWeight: "500" as "500",
    FontFace: "Inter",
    color: "#001A19",
  },
  heading3: {
    fontSize: 16,
    lineHeight: 24,
    marginVertical: 4,
    fontWeight: "500" as "500",
    FontFace: "Inter",
    color: "#001A19",
  },
  link: { color: "#1DAA75" },
  break: { marginVertical: 4 },
  code_inline: {
    backgroundColor: "transparent",
    borderColor: "transparent",
    borderWidth: 0,
    color: "#001A19",
    fontFamily: "monospace",
    padding: 0,
  },
  code_block: {
    backgroundColor: "transparent",
    borderColor: "transparent",
    borderWidth: 0,
    color: "#001A19",
    fontFamily: "monospace",
    padding: 0,
  },
  fence: {
    backgroundColor: "transparent",
    borderColor: "transparent",
    borderWidth: 0,
    color: "#001A19",
    fontFamily: "monospace",
    padding: 0,
  },
};
